import PropTypes from "prop-types";
import React, { Component } from "react";
import DataTable from "react-md/lib/DataTables/DataTable";
import TableHeader from "react-md/lib/DataTables/TableHeader";
import TableBody from "react-md/lib/DataTables/TableBody";
import TableRow from "react-md/lib/DataTables/TableRow";
import TableColumn from "react-md/lib/DataTables/TableColumn";
import { dateTimeToString } from "components/Shared/Formatters";

class QaRejectionList extends Component {
  constructor(props, context) {
    super(props, context);
    this.callOnRejectionClicked = this.callOnRejectionClicked.bind(this);
  }

  callOnRejectionClicked(rejection) {
    if (this.props.onRejectionClicked) {
      this.props.onRejectionClicked(rejection);
    }
  }

  render() {

    return (
      <>
        {this.props.viewOnly
          ? <div>Please see Case Actions to Respond</div>
          : <div />}
        <DataTable plain>
          <TableHeader>
            <TableRow>
              <TableColumn grow={false} style={{ maxWidth: 100, height: 30 }}>Date Created</TableColumn>
              <TableColumn style={{ width: "40%", minWidth: 250, maxWidth: 600, height: 30 }}>Reason</TableColumn>
              <TableColumn grow={false} style={{ maxWidth: 100, height: 30 }}>Date Responded</TableColumn>
              <TableColumn style={{ width: "40%", minWidth: 250, maxWidth: 600, height: 30 }}>Response</TableColumn>
            </TableRow>
          </TableHeader>
          <TableBody>
            {this.props.qaAppraisalRejections.map((rejection) => (
              <TableRow key={rejection.id} onClick={() => { if (this.props.enabled) { this.callOnRejectionClicked(rejection); } }}>
                <TableColumn>{dateTimeToString(rejection.createdDate)}</TableColumn>
                <TableColumn>{rejection.reasonNotes}</TableColumn>
                <TableColumn>{dateTimeToString(rejection.responseDate)}</TableColumn>
                <TableColumn>{rejection.responseNotes}</TableColumn>
              </TableRow>
            ))}
          </TableBody>
        </DataTable>
      </>
    );
  }
}

QaRejectionList.propTypes = {
  enabled: PropTypes.bool.isRequired,
  qaAppraisalRejections: PropTypes.array.isRequired,
  onRejectionClicked: PropTypes.func,
  viewOnly: PropTypes.bool.isRequired,
};
export default QaRejectionList;